module.exports = __webpack_public_path__ + "img/exclamation-octagon-fill.3d047690.svg";